import React from "react";
import { useInView } from "react-intersection-observer";
import logoEmpatica from "../../recursos/Logo-Empatica.png";
import fondoFooterMovil from "../../recursos/Fondo-Footer-Movil.png";
import empaticaRegular from "../../fonts/Branding-Semilight.otf";
import empaticaBold from "../../fonts/Branding-Bold.otf";
import empaticaMedium from "../../fonts/Branding-Medium.otf";
import imgDerecha from "../../recursos/Morelia.png";
import imgIzquierda from "../../recursos/Isotipo-Bco-ES.png";
import { Link } from "react-router-dom";

const Footer2 = () => {
    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.2,
    });

    const animatedText = (text, baseDelay = 0) =>
        text.split("").map((char, i) => (
            <span
                key={i}
                className={`inline-block opacity-0 ${inView ? "animate-fade-in" : ""}`}
                style={{ animationDelay: `${baseDelay + i * 0.03}s` }}
            >
                {char === " " ? "\u00A0" : char}
            </span>
        ));

    const linksInteres = [
        { text: "PagaTuAgua.com", href: "https://pagatuagua.com/", external: true },
        { text: "Siscom", href: "#siscom" },
        { text: "Productos", href: "#productos" },
        { text: "Alianzas", href: "#alianzas" },
        { text: "Contáctanos", href: "https://wa.me/524434799929?text=Hola%20Mariana%20de%20Empatica,%20v%C3%AD%20tu%20pagina%20y%20me%20interesa%20m%C3%A1s%20informaci%C3%B3n%20del%20Quickpaymini", external: true },
        { text: "Garantías", href: "/publico/documentos/poliza-garantia", external: true }
    ];

    const otrosLinks = [
        { text: "Menú inicial", to: "/empaticapage" },
        { text: "Sector Privado", to: "/empaticapage/privado" },
        { text: "Consultoría", to: "/empaticapage/consultoria" },
        { text: "Quickpaymini", href: "https://quickpay.empatica.mx/", external: true },
        { text: "Aviso de privacidad general", href: "/publico/documentos/aviso-privacidad-general", external: true },
        { text: "Somos seguros", href: "/publico/documentos/somos-seguros", external: true },
        { text: "Alta Sistec", href: "/publico/documentos/alta-sistec", external: true },
    ];

    return (
        <footer
            ref={ref}
            className="text-white py-16 px-4 md:px-16 text-lg font-[EmpaticaMedium] w-full min-h-[250px] rounded-3xl overflow-hidden relative bg-[#2e59a4] mt-[230%] sm:mt-72 md:mt-32">
            {/* Fondo para pantallas grandes */}
            <img
                src={imgIzquierda}
                alt="Fondo izquierdo"
                className="hidden md:block absolute left-0 bottom-0 h-full object-contain"
            />
            <img
                src={imgDerecha}
                alt="Fondo derecho"
                className="hidden md:block absolute right-0 bottom-0 h-full object-contain"
            />

            {/* Fondo para celular */}
            <img
                src={fondoFooterMovil}
                alt="Fondo móvil"
                className="block md:hidden absolute inset-0 w-full h-full object-cover "
            />

            <div className="flex flex-col md:flex-row items-center justify-between gap-8 rounded-3xl overflow-hidden">
                {/* Logo */}
                <div className="flex flex-col items-center w-full md:w-auto md:mt-44">
                    <img
                        src={logoEmpatica}
                        alt="Logo Empatica"
                        className="w-36 md:w-72 h-auto object-contain mb-4 md:mb-0 md:ml-28 "
                    />

                </div>
                {/* Links de interés */}
                <div className="flex flex-col md:flex-row gap-8 md:gap-16 w-full md:w-auto items-center text-center md:text-left md:items-start">
                    <div className="flex flex-col gap-2 md:ml-16">
                        <h3 className="text-3xl font-bold font-[EmpaticaBold]">{animatedText("Links de Interés", 0.1)}</h3>
                        {linksInteres.map(({ text, href, to, external }, i) => (
                            to ? (
                                <Link
                                    key={i}
                                    to={to}
                                    className="hover:underline"
                                >
                                    {animatedText(text, 0.3 + i * 0.1)}
                                </Link>
                            ) : (
                                <a
                                    key={i}
                                    href={href}
                                    className="hover:underline"
                                    {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                >
                                    {animatedText(text, 0.3 + i * 0.1)}
                                </a>
                            )
                        ))}
                    </div>
                    <div className="flex flex-col gap-2 mt-8">
                        {otrosLinks.map(({ text, href, to, external }, i) => (
                            to ? (
                                <Link
                                    key={i}
                                    to={to}
                                    className="hover:underline"
                                >
                                    {animatedText(text, 0.3 + i * 0.1)}
                                </Link>
                            ) : (
                                <a
                                    key={i}
                                    href={href}
                                    className="hover:underline"
                                    {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                >
                                    {animatedText(text, 0.3 + i * 0.1)}
                                </a>
                            )
                        ))}

                    </div>
                </div>

                {/* Redes sociales */}
                <div className="grid grid-cols-3 gap-4 text-5xl justify-items-center md:w-auto md:mr-24 mx-auto">
                </div>
            </div>

            {/* Copyright */}
            <div className="mt-10 text-sm text-center font-semibold">
                {animatedText("© Empatica Soluciones, 2025", 2)}
            </div>

            {/* Keyframes y fuentes embebidas */}
            <style>
                {`
                    @font-face {
                        font-family: 'EmpaticaMedium';
                        src: url(${empaticaMedium}) format('opentype');
                        font-weight: normal;
                        font-style: normal;
                    }

                    @font-face {
                        font-family: 'EmpaticaRegular';
                        src: url(${empaticaRegular}) format('opentype');
                        font-weight: normal;
                        font-style: normal;
                    }

                    @font-face {
                        font-family: 'EmpaticaBold';
                        src: url(${empaticaBold}) format('opentype');
                        font-weight: bold;
                        font-style: normal;
                    }

                    @keyframes float {
                        0% { transform: translateY(0); }
                        50% { transform: translateY(-6px); }
                        100% { transform: translateY(0); }
                    }

                    @keyframes fadeInChar {
                        0% { opacity: 0; transform: translateY(10px); }
                        100% { opacity: 1; transform: translateY(0); }
                    }

                    .animate-float {
                        animation: float 3s ease-in-out infinite;
                    }

                    .animate-fade-in {
                        animation: fadeInChar 0.3s ease forwards;
                    }
                `}
            </style>
        </footer>
    );
};

export default Footer2;
